const account = {
  state: {
    sysParams: {},
    bannedReason: '',
    accountEntity: {},
    notExist: false,
    activeKey: 1,
    noticeCount: 0,
    sysNoticeCount: 0,
    fansCount: 0
  },
  mutations: {
    SET_ACTIVE_KEY: (state, value) => {
      state.activeKey = value
    },
    SET_ACCOUNT_SYSPARAMS: (state, sysParams) => {
      state.sysParams = sysParams
    },
    SET_ACCOUNT_ENTITY: (state, accountEntity) => {
      state.accountEntity = accountEntity
    },
    SET_ACCOUNT_BANNEDREASON: (state, bannedReason) => {
      state.bannedReason = bannedReason
    },
    SET_ACCOUNT_NOT_EXIST: (state, notExist) => {
      state.notExist = notExist
    },
    SET_NOTICE_COUNT: (state, count) => {
      state.noticeCount = count
    },
    SET_SYS_NOTICE_COUNT: (state, count) => {
      state.sysNoticeCount = count
    },
    SET_FANS_COUNT: (state, count) => {
      state.fansCount = count
    }
  },
  actions: {
    setAccountMessage ({ commit }, data) {
      commit('SET_ACCOUNT_SYSPARAMS', data.sysParams)
      commit('SET_ACCOUNT_ENTITY', data.accountEntity)
      commit('SET_ACCOUNT_BANNEDREASON', data.bannedReason)
      commit('SET_ACCOUNT_NOT_EXIST', !!data.notExist)
    },
    setNoticeCount ({ commit }, count) {
      commit('SET_NOTICE_COUNT', count)
    },
    setSysNoticeCount ({ commit }, count) {
      commit('SET_SYS_NOTICE_COUNT', count)
    },
    setfansCount ({ commit }, count) {
      commit('SET_FANS_COUNT', count)
    }
  }
}

export default account
